import { useTranslation } from 'react-i18next';

const floatingProducts = [
  { src: 'https://readdy.ai/api/search-image?query=White%20chunky%20sneaker%20product%20photography%20isolated%20on%20light%20beige%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20soft%20natural%20lighting%2C%20high%20detail%20texture&width=280&height=280&seq=hero-float-01&orientation=squarish', className: 'absolute bottom-32 right-16 md:right-32 w-20 h-20 md:w-28 md:h-28 rounded-2xl rotate-6 opacity-80' },
  { src: 'https://readdy.ai/api/search-image?query=Designer%20leather%20handbag%20product%20photography%20isolated%20on%20light%20neutral%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20soft%20natural%20lighting%2C%20high%20detail&width=240&height=240&seq=hero-float-02&orientation=squarish', className: 'absolute top-28 right-8 md:right-20 w-16 h-16 md:w-24 md:h-24 rounded-2xl -rotate-3 opacity-70' },
  { src: 'https://readdy.ai/api/search-image?query=Fashionable%20sunglasses%20product%20photography%20isolated%20on%20light%20beige%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20soft%20natural%20lighting&width=200&height=200&seq=hero-float-03&orientation=squarish', className: 'absolute top-40 right-48 md:right-80 w-14 h-14 md:w-20 md:h-20 rounded-2xl rotate-12 opacity-75 hidden md:block' },
  { src: 'https://readdy.ai/api/search-image?query=Premium%20baseball%20cap%20product%20photography%20isolated%20on%20light%20neutral%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20soft%20natural%20lighting&width=200&height=200&seq=hero-float-04&orientation=squarish', className: 'absolute bottom-48 right-56 md:right-96 w-16 h-16 md:w-22 md:h-22 rounded-2xl -rotate-6 opacity-70 hidden lg:block' },
  { src: 'https://readdy.ai/api/search-image?query=Sporty%20watch%20product%20photography%20isolated%20on%20light%20beige%20background%2C%20clean%20minimalist%20ecommerce%20shot%2C%20soft%20natural%20lighting%2C%20high%20detail&width=180&height=180&seq=hero-float-05&orientation=squarish', className: 'absolute top-56 right-36 md:right-60 w-12 h-12 md:w-18 md:h-18 rounded-2xl rotate-3 opacity-65 hidden md:block' },
];

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] md:h-[720px] flex items-end overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Flat%20lay%20fashion%20products%20arrangement%20on%20light%20beige%20background%2C%20sneakers%20streetwear%20accessories%20bags%20watches%20scattered%20artistically%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="YOYBUY fashion products"
          className="w-full h-full object-cover"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/60" />
      </div>

      {/* Floating product cards */}
      {floatingProducts.map((product, i) => (
        <div
          key={i}
          className={`${product.className} z-10 border-2 border-white/30 shadow-xl overflow-hidden transition-all duration-700 hover:scale-110 hover:rotate-0 hover:opacity-100`}
          style={{ animationDelay: `${i * 0.2}s` }}
        >
          <img src={product.src} alt="floating product" className="w-full h-full object-cover" />
        </div>
      ))}

      {/* Decorative blurred circles */}
      <div className="absolute top-20 left-10 w-40 h-40 bg-rose-200/20 rounded-full blur-3xl hidden md:block" />
      <div className="absolute bottom-20 left-1/4 w-60 h-60 bg-amber-200/15 rounded-full blur-3xl hidden md:block" />
      <div className="absolute top-1/3 right-1/3 w-32 h-32 bg-emerald-200/15 rounded-full blur-2xl hidden md:block" />

      {/* Content */}
      <div className="relative z-10 w-full px-6 lg:px-10 pb-16 md:pb-24">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white/90 text-xs font-medium tracking-wide mb-6 backdrop-blur-sm">
            {t('hero.tag')}
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-medium text-white leading-[1.1] tracking-tight">
            {t('hero.title')}
          </h1>

          <p className="mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-lg">
            {t('hero.subtitle')}
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-stone-900 text-sm font-semibold rounded-full hover:bg-stone-100 transition-colors whitespace-nowrap shadow-lg shadow-black/10"
            >
              {t('hero.cta')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}